import React, { useEffect } from 'react'
import { useState } from 'react'
import { Link, Outlet, NavLink, useParams } from 'react-router-dom'
import "./orgStyle.css"
import { api } from '../../app/Api/ApiSlice'



const Manage = ({ }) => {
    const { organization } = useParams()
    const [members, setMembers] = useState([])
    const [friends, setFriends] = useState([])
    const [isAdmin, setIsAdmin] = useState(false)

    useEffect(() => {
        const getOrgInfo = async () => {
            const response = await api.get(`/${organization}`)
            // console.log(response)
            if (response) {
                setMembers(response.data.org.membersCount)
                setFriends(response.data.org.friendsCount)
                setIsAdmin(response.data.org.isAdmin)
            }
        }

        getOrgInfo()
    }, [])

    // const isAdmin = true
    return (
        <div className='page-body'>
            <div className="multi-content-page">
                <div className="page-side-menu">
                    <div className="menu-items-list">
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/`}>Home</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/admin/members/requests`}>Membership Requests</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/admin/friends/requests`}>Friendship Requests</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/admin/moderation`}>Moderate</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/admin/branches`}>Branches</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/admin/blacklisteds`}>Blacklisteds</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/admin/admins`}>Admins</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/admin/suggestions`}>Suggestion Box</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/admin/promotions`}>Promotions</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/admin/settings`}>Settings</NavLink>
                        </div>
                    </div>
                </div>
                <div className="org-content">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Manage